// extracted by mini-css-extract-plugin
export default {"root":"TwMXG8"};